import React from 'react';

const Footer: React.FC = () => {
    return (
        <div className="footer sticky-section d-flex flex-column justify-content-center align-items-center text-center">
            <div className="contactFooter mb-2">
                Correo electrónico: <a href="mailto:info@pomarrosaes.com">info@pomarrosaes.com</a>
            </div>
            <div className="contactFooter mb-2">
                Teléfono: 961 819 9591
            </div>
            <div>
                <img className="logoFooter" src="/assets/logo_pomarrosa_t.png" alt="Logo Pomarrosa"/>
            </div>
            <div className="pt-5">
                <a target="_blank" href="https://www.facebook.com/pomarrosaes"><img className="social" src="/assets/logos/facebook.png" alt="fb"/></a>
                <a target="_blank" href="https://www.instagram.com/pomarrosaes"><img className="social" src="/assets/logos/instagram.png" alt="insta"/></a>
                <a target="_blank" href="https://www.youtube.com/@pomarrosaes"><img className="social" src="/assets/logos/youtube.png" alt="insta"/></a>
            </div>
        </div>
    );
};

export default Footer;
